import {
  defineAsyncMicroApp,
  unmountApp,
} from '@gohighlevel/ghl-module-federation-plugin'

let calendarIntegrationApp: any = {}
let calendarScheduleApp: any = {}

function useAppContext() {
  function mountAppContext(apps: any) {
    for (const iterator in apps) {
      window[iterator] = apps[iterator]
    }
  }
  return { mountAppContext }
}

export async function mountCalendarSettingsApp(
  mountId: string,
  configuration: any
) {
  if (calendarIntegrationApp?.unmount) {
    calendarIntegrationApp.unmount()
  }
  if (calendarScheduleApp?.unmount) {
    calendarScheduleApp.unmount()
  }

  const { mountAppContext } = useAppContext()
  let Component
  switch (mountId) {
    case 'CalendarIntegration':
      Component = 'CalendarIntegration'
      break
    case 'CalendarSchedule':
      Component = 'CalendarSchedule'
      break
    default:
      Component = null
  }

  const [createApp, mountApp] = await defineAsyncMicroApp(
    'calendarSettingsApp',
    ['vue3', Component]
  )

  const calendarSettingsApp = createApp(mountApp, {
    ...configuration,
  })
  mountAppContext({ calendarSettingsAppInstance: calendarSettingsApp })
  calendarSettingsApp.mount(`#${mountId}`)

  if (mountId === 'CalendarIntegration') {
    calendarIntegrationApp = calendarSettingsApp
  } else if (mountId === 'CalendarSchedule') {
    calendarScheduleApp = calendarSettingsApp
  }
}

export function unmountCalendarSettingsApp(mountId: string) {
  let appToUnmount

  switch (mountId) {
    case 'CalendarIntegration':
      appToUnmount = calendarIntegrationApp
      break
    case 'CalendarSchedule':
      appToUnmount = calendarScheduleApp
      break
    default:
      break
  }
  if (appToUnmount?.unmount) {
    appToUnmount.unmount()
    unmountApp('calendarSettingsApp')
  }
}
